<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="编码：">
            <el-input v-model="query.goodsCode" placeholder="请输入商品/聚水潭编码" clearable size="small" />
          </el-form-item>
          <el-form-item label="商品名称：">
            <el-input v-model="query.name" placeholder="请输入商品名称" clearable size="small" />
          </el-form-item>
          <el-form-item :label="isIntegral?'积分分类':'商品分类'">
            <el-cascader v-model="categorizeIdArr" :options="categorizeOptions" :props="{ checkStrictly: true , label: 'name',value: 'id',children: 'child'}" clearable size="small"></el-cascader>
          </el-form-item>

          <el-form-item label="是否为预售商品：" v-if="!isIntegral">
            <el-select v-model="query.isPresale" placeholder="请选择" clearable size="small">
              <!-- <el-option label="全部" :value="undefined"></el-option> -->
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否限制时间：">
            <el-select v-model="query.isControlTime" placeholder="请选择" clearable size="small">
              <!-- <el-option label="全部" :value="undefined"></el-option> -->
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="有无规格：">
            <el-select v-model="query.isMoreSpec" placeholder="请选择" clearable size="small">
              <el-option label="有" :value="1"></el-option>
              <el-option label="无" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.state" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="上架" :value="1"></el-option>
              <el-option label="下架" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <!-- REQ-2026-470053 平台标签筛选，多选之间是或的关系 -->
          <el-form-item label="平台标签：" v-if="!isIntegral">
            <el-select v-model="query.platformTagCodeList" placeholder="请选择" multiple collapse-tags clearable size="small">
              <el-option v-for="item in platformTagOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签状态：" v-if="!isIntegral">
            <el-select v-model="query.platformTagStatus" placeholder="生效中" clearable size="small">
              <el-option label="生效中" :value="undefined"></el-option>
              <el-option label="已过期" :value="2"></el-option>
              <el-option label="已取消" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间区域：">
            <!-- 时间筛选类型 -1默认全部 1创建时间 2修改时间 3上下架时间 4活动时间" -->
            <el-select v-model="timeType" placeholder="请选择" clearable size="small">
              <el-option label="上下架时间" :value="3"></el-option>
              <el-option label="修改时间" :value="2"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="是否APP展示：" v-if="!isIntegral">
            <el-select
              v-model="query.isShowApp"
              placeholder="全部"
              clearable
              size="small"
              @clear="query.isShowApp = undefined"
            >
              <el-option label="展示" :value="1"></el-option>
              <el-option label="不展示" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">

      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="1"></el-tab-pane>
          <el-tab-pane label="首页推荐商品" name="2" v-if="!isIntegral"></el-tab-pane>
          <el-tab-pane name="3"><span slot="label">库存紧张({{inventoryShortage}})</span></el-tab-pane>
          <el-tab-pane label="预售商品" name="4"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="2" v-hasPermi="['goods:goods:state']">批量下架</el-dropdown-item>
              <el-dropdown-item :command="1" v-hasPermi="['goods:goods:state']">批量上架</el-dropdown-item>
              <el-dropdown-item :command="3" v-if="!isIntegral" v-hasPermi="['goods:goods:recommend']">批量设为推荐商品</el-dropdown-item>
              <el-dropdown-item :command="4" v-if="!isIntegral" v-hasPermi="['goods:goods:recommend']">批量取消推荐</el-dropdown-item>
              <!-- REQ-2026-470053-22：平台标签批量操作从共用「商品编辑」权限拆成独立权限点，
                   这样能单独收回，不必连商品编辑一起停。增量 SQL 已把该权限授给当前持有
                   goods:goods:edit 的角色，发版当天不会有人失能；后续收紧由管理员在角色管理里取消勾选。 -->
              <el-dropdown-item :command="5" v-if="!isIntegral" divided v-hasPermi="['goods:platformTag:batch']">批量设置平台标签</el-dropdown-item>
              <el-dropdown-item :command="6" v-if="!isIntegral" v-hasPermi="['goods:platformTag:batch']">批量调整标签有效期</el-dropdown-item>
              <el-dropdown-item :command="7" v-if="!isIntegral" v-hasPermi="['goods:platformTag:batch']">批量取消平台标签</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" size="mini" @click="handleDownload" plain v-if="!isIntegral" v-hasPermi="['goods:goods:export']">导出</el-button>
          <el-button type="primary" size="mini" @click="handleSync" plain v-hasPermi="['goods:goods:inventory']">同步库存</el-button>
          <el-button type="primary" size="mini" @click="handleJuShuiTan" plain v-hasPermi="['goods:goods:inventory']">同步聚水潭</el-button>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['goods:goods:add']">新增商品</el-button>
          <img src="../../../assets/Vector.png" class="vector" @click="handleChangeFields" v-if="!isIntegral">
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange" >
        <el-table-column type="selection" width="50" fixed />
        <el-table-column :min-width="item.width" v-for="(item,index) in dynamicHeaders" :key="index" :prop="item.prop" :label="item.label" :fixed="item.prop === 'uuid' || item.prop === 'name'" :sortable="item.isSortable" :show-overflow-tooltip="item.showToolTip">
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleShow(row)" v-if="item.prop === 'name'" :key="'name-' + index">{{row.name}}</el-link>
            <span v-for="(catItem,catIndex) in row.sysGoodsCategorizeList" :key="'cat-' + catIndex" v-else-if="item.prop === 'sysGoodsCategorizeList'">{{catItem.name}}{{row.sysGoodsCategorizeList.length - 1 != catIndex?',':''}}</span>
            <el-image style="width: 50px; height: 50px" :src="row.img" :preview-src-list="[row.img]" v-else-if="item.prop === 'img'" :key="'img-' + index"></el-image>
            <span v-for="(areaItem,areaIndex) in row.sysGoodsAreaList" :key="'area-' + areaIndex" v-else-if="item.prop === 'sysGoodsAreaList'">{{mallAreaName(areaItem)}}{{row.sysGoodsAreaList.length - 1 != areaIndex?',':''}}</span>
            <span v-else-if="item.prop === 'isControlTime'" :key="'time-' + index">{{row.isControlTime?'限制':'不限制'}}</span>
            <span v-else-if="item.prop === 'isShowApp'" :key="'showApp-' + index">{{row.isShowApp===1?'展示':'不展示'}}</span>
            <span v-else-if="item.prop === 'canInvoice'" :key="'canInvoice-' + index">{{row.canInvoice===1?'支持':'不支持'}}</span>
            <span v-else-if="item.prop === 'listingStartTime'" :key="'listing-' + index">{{row.listingStartTime}} ~ {{row.listingEndTime}}</span>
            <!-- REQ-2026-470053 平台标签列：生效中的高亮，已过期/已取消灰显，鼠标悬停看来源和有效期 -->
            <div v-else-if="item.prop === 'platformTagList'" :key="'ptag-' + index">
              <template v-if="row.platformTagList && row.platformTagList.length">
                <el-tooltip v-for="tag in row.platformTagList" :key="tag.tagCode" placement="top">
                  <div slot="content">
                    来源：{{ tag.sourceName }}<br>
                    有效期：{{ tag.effectiveAt }} ~ {{ tag.expiredAt }}<br>
                    状态：{{ platformTagStatusText(tag) }}<br>
                    最后操作：{{ tag.operatedBy || '-' }} {{ tag.operatedTime || '' }}
                  </div>
                  <el-tag
                    size="mini"
                    class="ptag"
                    :type="tag.effective ? (tag.tagCode === 'HOT' ? 'danger' : 'primary') : 'info'"
                  >{{ tag.tagName }}{{ tag.effective ? '' : '(' + platformTagStatusText(tag) + ')' }}</el-tag>
                </el-tooltip>
              </template>
              <span v-else>-</span>
            </div>
            <!-- REQ-2026-826259 商品活动标签：该商品参加的活动名称，多个则多个显示 -->
            <div v-else-if="item.prop === 'activityTagList'" :key="'actTag-' + index">
              <el-tag v-for="(tag,tagIndex) in row.activityTagList" :key="'tag-' + tagIndex"
                      size="mini" type="success" class="activity-tag">{{tag}}</el-tag>
              <span v-if="!row.activityTagList || !row.activityTagList.length">-</span>
            </div>
            <div v-else-if="item.prop === 'supportedPayModesName'" :key="'payMode-' + index">
              {{row.supportedPayModesName || '-'}}
              <el-tag v-if="row.cashOnly" size="mini" type="warning">只支持现金</el-tag>
            </div>
            <div v-else-if="item.prop === 'state'" :key="'state-' + index">
              <el-switch v-model="row.state" :active-value="1" :inactive-value="2" v-hasPermi="['goods:goods:state']" @change="changeSwitch(row)"></el-switch>
              {{row.state === 1?'启用':'禁用'}}
            </div>
            <span v-else :key="'default-' + index">{{ row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['goods:goods:edit']">编辑</el-button>
            <el-button type="text" @click="handleRecommend(row.id,row.isTopRecommend?0:1)" v-if="!isIntegral" v-hasPermi="['goods:goods:recommend']">{{row.isTopRecommend?'取消推荐':'设为推荐'}}</el-button>
            <el-button type="text" @click="handleLog(row)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <goods-add ref="goodsAdd" :isIntegeal="isIntegral" @created="doQueryList({})" :categorizeOptions="categorizeOptions" />
    <change-fields-vue ref="fieldsPopup" :allTemplate="allTemplate" :cList="dynamicHeaders" @updated="doColumnList" />
    <!-- REQ-2026-470053 平台标签批量操作 -->
    <platform-tag-batch ref="platformTagBatch" @updated="doQueryList({})" />
  </div>
</template>

<script>
import goodsAdd from './add'
import sysGoodsApi from '@/api/goods/sysGoods'
import Pagination from '@/components/Pagination'
import sysGoodsCategorizeApi from '@/api/goods/sysGoodsCategorize'
import changeFieldsVue from '@/views/common/changeFields.vue'
import platformTagBatch from './platformTagBatch.vue'
import sysGoodsPlatformTagApi from '@/api/goods/sysGoodsPlatformTag'
import { Subtr } from '@/utils/index'
import { mallAreaName } from './mallPayMode'
// REQ-2026-470053 「平台标签」列已给老用户补过一次的标记
const PLATFORM_TAG_COLUMN_FLAG = 'goodsTableColumn_platformTag'
// REQ-2026-826259 #12④「商品活动标签」列同上。
// ⚠️ **每加一个新列都要配一个自己的标记**，不能共用一个 —— 共用的话，
// 先加的列补过之后标记就置上了，后加的列对老用户永远补不上。
const ACTIVITY_TAG_COLUMN_FLAG = 'goodsTableColumn_activityTag'
export default {
  props: ['isIntegral'],
  components: {
    Pagination,
    goodsAdd,
    changeFieldsVue,
    platformTagBatch
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        areaIdList: "3,4,5",
        goodsCode: undefined,
        name: undefined,
        categorizeId: undefined,
        isPresale: undefined,
        isControlTime: undefined,
        isMoreSpec: undefined,
        isShowApp: undefined,
        state: undefined,
        // REQ-2026-470053 平台标签筛选
        platformTagCodeList: [],
        platformTagStatus: undefined
      },
      platformTagOptions: [],
      categorizeIdArr: [],
      selectItems: [],
      dateTime: [],
      activeName: '1',
      categorizeOptions: [],  //商品分类
      isShows: false,
      treeDate: [],
      allTemplate: [{ label: '商品编码', prop: 'uuid',width: 150 }, { label: '商品名称', prop: 'name',width: 200 }, { label: '聚水潭编码', prop: 'yyCode',width: 150 }, { label: this.isIntegral ? '积分分类' : '商品分类', prop: 'sysGoodsCategorizeList' }
        , { label: '商品主图', prop: 'img' }, { label: this.isIntegral?'积分价':'商品零售价', prop: 'retailPrice' }, { label: '总库存', prop: 'inventory' }, { label: '销量', prop: 'allSalesCount' }, { label: '排序', prop: 'sort' },
      { label: '是否限制时间', prop: 'isControlTime' }, { label: '上下架时间', prop: 'listingStartTime' }, { label: '修改时间', prop: 'operatedTime' },{label: '是否APP展示', prop: 'isShowApp'},{label: '是否开票', prop: 'canInvoice'}, { label: '平台标签', prop: 'platformTagList', width: 160 },
      // REQ-2026-234328 商品规格（如「10片/盒」）。列表默认列由 allTemplate 决定，
      // 用户自定义过列的（changeFields 存了模板）不会自动多出这一列，要自己去「自定义列」里勾。
      { label: '产品规格', prop: 'productSpec', width: 120 },
      { label: '支持的支付方式', prop: 'supportedPayModesName', width: 160 },
      { label: '商品活动标签', prop: 'activityTagList', width: 180 },
      { label: '状态', prop: 'state' }],
      dynamicHeaders: [],
      inventoryShortage: 0,
      timeType: ''
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    this.getSelectOptions()
    this.getFieled()
    if (!this.isIntegral) this.getPlatformTagOptions()
  },
  methods: {
    mallAreaName,
    handleClick() {
      this.query.isTopRecommend = undefined
      this.query.inventoryState = undefined
      if (this.activeName === '1') {

      } else if (this.activeName === '2') {
        this.query.isTopRecommend = 1
      } else if (this.activeName === '3') {
        this.query.inventoryState = 2
      } else if (this.activeName === '4') {
        this.query.inventoryState = 1
      }
      this.doQueryList({ pageNo: 1 })
    },
    getFieled() {
      if (this.isIntegral) {
        this.dynamicHeaders = this.allTemplate
      } else {
        let findIdx = this.allTemplate.findIndex(it => it.prop === 'isControlTime')
        let obj = { label: '显示商城', prop: 'sysGoodsAreaList' }
        if (findIdx) this.allTemplate.splice(findIdx, 0, obj)
        if (localStorage.getItem('goodsTableColumn')) {
          let tColumn = JSON.parse(localStorage.getItem('goodsTableColumn'))
          // BUG-2026-395890：列名改为「显示商城」，老用户缓存里存的是旧列名，按 prop 覆盖
          tColumn.forEach(col => { if (col.prop === 'sysGoodsAreaList') col.label = obj.label })
          // 平台标签是后加的列，老用户的 localStorage 里没有，给他们补一次，
          // 否则新列对他们永远不显示。补过就打标记：之后用户自己取消勾选这一列，
          // 不会在下次进页面时又被强行加回来。
          if (!localStorage.getItem(PLATFORM_TAG_COLUMN_FLAG)) {
            const tplIdx = this.allTemplate.findIndex(it => it.prop === 'platformTagList')
            if (tplIdx > -1 && !tColumn.some(it => it.prop === 'platformTagList')) {
              tColumn.splice(Math.min(tplIdx, tColumn.length), 0, this.allTemplate[tplIdx])
              localStorage.setItem('goodsTableColumn', JSON.stringify(tColumn))
            }
            localStorage.setItem(PLATFORM_TAG_COLUMN_FLAG, '1')
          }
          // REQ-2026-826259 #12④「商品活动标签」列同理：**只加列不补回填，
          // 对所有用过这个页面的老用户（基本就是全部运营）这一列永远不显示** ——
          // 而这个需求的原始报告恰恰就是"这一列永远为空"，
          // 上线后极可能被原样再报一次，那时候代码却是对的。
          if (!localStorage.getItem(ACTIVITY_TAG_COLUMN_FLAG)) {
            const actIdx = this.allTemplate.findIndex(it => it.prop === 'activityTagText')
            if (actIdx > -1 && !tColumn.some(it => it.prop === 'activityTagText')) {
              tColumn.splice(Math.min(actIdx, tColumn.length), 0, this.allTemplate[actIdx])
              localStorage.setItem('goodsTableColumn', JSON.stringify(tColumn))
            }
            // 补过就打标记：之后用户自己取消勾选这一列，不会下次进页面又被强行加回来
            localStorage.setItem(ACTIVITY_TAG_COLUMN_FLAG, '1')
          }
          tColumn = this.migrateActivityColumns(tColumn)
          this.dynamicHeaders = tColumn
        } else {
          this.dynamicHeaders = this.allTemplate
        }
      }
    },
    /**
     * REQ-2026-826259 一次性把新增的活动列补进用户已保存的列配置里。
     *
     * 列配置存在 localStorage，老用户的那份里没有新列，不迁移的话新列永远不显示，
     * 运营会以为功能没上。用一个迁移标记只补一次，之后用户自己取消勾选的不再被强行加回来。
     */
    migrateActivityColumns(tColumn) {
      const MIGRATED_KEY = 'goodsTableColumn_activityRuleMigrated'
      if (localStorage.getItem(MIGRATED_KEY)) return tColumn
      const newProps = ['supportedPayModesName', 'activityTagList']
      const merged = tColumn.slice()
      newProps.forEach(prop => {
        if (merged.some(it => it.prop === prop)) return
        const define = this.allTemplate.find(it => it.prop === prop)
        if (!define) return
        // 插到「状态」列前面，跟 allTemplate 里的位置保持一致
        const stateIdx = merged.findIndex(it => it.prop === 'state')
        if (stateIdx > -1) merged.splice(stateIdx, 0, define)
        else merged.push(define)
      })
      localStorage.setItem(MIGRATED_KEY, '1')
      localStorage.setItem('goodsTableColumn', JSON.stringify(merged))
      return merged
    },
    doColumnList(checkedList) {
      if (checkedList && !checkedList.length) return
      let allList = JSON.parse(JSON.stringify(this.allTemplate))
      let newL = allList.filter(item => checkedList.indexOf(item.prop) > -1)
      this.dynamicHeaders = newL;
      localStorage.setItem('goodsTableColumn', JSON.stringify(newL))
    },
    handleChangeFields() {
      this.$refs.fieldsPopup.open();
    },
    handleFilter() {
      // 平台标签是多选，重置成 [] 而不是 undefined，否则 el-select multiple 拿不到数组会报错
      this.query = { isShowApp: undefined, platformTagCodeList: [], platformTagStatus: undefined }
      this.categorizeIdArr = [];
      this.timeType = ''
      this.dateTime = []
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    getSelectOptions() {
      sysGoodsCategorizeApi.fetchTreeList({ pageNo: 1, pageSize: 1000, goodsAreaIds: this.isIntegral ? '2' : '3,4,5', isEnable: true }).then(({ data }) => {
        this.categorizeOptions = this.formatCascaderData(data.list)
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    selectionChange(val) {
      this.selectItems = val
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择商品')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      if (command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command === 2) {
        this.handleBatchState(ids, 2)
      } else if (command === 3) {
        this.handleRecommend(ids, 1)
      } else if (command === 4) {
        this.handleRecommend(ids, 0)
      } else if (command === 5) {
        this.$refs.platformTagBatch.open('set', ids)
      } else if (command === 6) {
        this.$refs.platformTagBatch.open('adjust', ids)
      } else if (command === 7) {
        this.$refs.platformTagBatch.open('cancel', ids)
      }
    },
    getPlatformTagOptions() {
      sysGoodsPlatformTagApi.options().then(({ data }) => {
        this.platformTagOptions = data || []
      })
    },
    platformTagStatusText(tag) {
      if (tag.status === 0) return '已取消'
      if (tag.status === 2) return '已过期'
      // status=1 但 effective=false，说明还没到生效时间或刚过期还没被定时任务回写
      return tag.effective ? '生效中' : '未生效'
    },
    handleBatchState(ids, type) {
      let txt = type === 1 ? '确认将选中商品批量上架？' : '确认将选中商品批量下架？'
      this.$common.confirm(txt).then(() => sysGoodsApi.batchState({ goodsId: ids, state: type }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    handleRecommend(ids, type) {
      let txt = type ? '是否设为推荐？' : '是否取消推荐？'
      this.$common.confirm(txt).then(() => sysGoodsApi.batchRecommend({ goodsId: ids, isTopRecommend: type }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },

    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    calcQuery() {
      if (this.isIntegral) this.query.isShowApp = undefined
      this.query.startTime = undefined
      this.query.endTime = undefined
      this.query.selTimeType = this.timeType
      if (this.dateTime && this.dateTime.length > 0) {
        this.query.startTime = this.dateTime[0]
        this.query.endTime = this.dateTime[1]
      }
      this.query.categorizeId = this.categorizeIdArr.length > 0 ? this.categorizeIdArr[this.categorizeIdArr.length - 1] : undefined
      this.query.areaIdList = this.isIntegral ? '2' : '3,4,5'
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.calcQuery()
      this.getInventoryShortage()
      let params = JSON.parse(JSON.stringify(this.query))
      if (this.activeName === '3') params.isTopRecommend = undefined
      this.listLoading = true
      return sysGoodsApi.fetchList(params).then(data => {
        let { list, total } = data.data;
        list.forEach(item => {
          item.allSalesCount = Subtr(item.actualSalesCount, -item.virtualSalesCount)
        });
        this.list = list
        this.total = total
      }).finally(() => {
        this.listLoading = false
      })
    },
    getInventoryShortage() {
      let params = JSON.parse(JSON.stringify(this.query))
      delete params.isTopRecommend
      sysGoodsApi.inventoryShortage(params)
        .then(data => {
          this.inventoryShortage = data.data
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    handleSync() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择商品')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      return this.$common.confirm('确认同步用友商品库存吗')
        .then(() => sysGoodsApi.synchronizeInventory({ ids: ids.toString() }))
        .then(() => {
          this.$common.showMsg('success', '库存已与用友同步成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    handleJuShuiTan() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择商品')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      return this.$common.confirm('确认同步聚水潭')
        .then(() => sysGoodsApi.synchronizeSysGoodsInfo({ ids: ids.toString() }))
        .then(() => {
          this.$common.showMsg('success', '同步成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择商品')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      sysGoodsApi.batchState({ goodsId: row.id, state: row.state }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      let type = this.isIntegral ? 2 : 3
      this.$refs.goodsAdd.handleCreate(this.total, type)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      let type = this.isIntegral ? 2 : 3
      this.$refs.goodsAdd.handleUpdate(row, type)
    },
    handleDownload() {
      this.$router.push("/export/list?code=ExportSysGoods&isIntegral=" + this.isIntegral)
    },
    handleLog(row) {
      this.$router.push("/log/log?type=1&id=" + row.id);
    }
  }
}
</script>
<style lang="scss" scoped>
.vector {
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-left: 10px;
}
.ptag {
  margin: 0 4px 2px 0;
}
/* REQ-2026-826259 商品活动标签，多个时换行显示 */
.activity-tag {
  margin: 0 4px 4px 0;
}
</style>
